/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EdrApiKey { 
    /**
     * Unique identifier for this API key. Format ONPREM:<UUID> for Carbon Black on-premises keys; GLOBAL for CrowdStrike.
     */
    api_key_id: string;
    /**
     * Client ID portion of the API key credential.
     */
    client_id: string;
    /**
     * Client secret portion of the API key credential. This field contains live credentials fetched from Secrets Manager on each request and is only returned to authenticated operator or tenant roles with the appropriate permissions. Treat this value as sensitive; do not log or cache it.
     */
    client_secret: string;
}

